module.exports = __webpack_public_path__ + "static/media/profile_pic.03b699af.jpg";